import { parseClientUrlParams } from '@lemonade-hq/uniclient-chat';
import type { ClientUrlParams, URLProps } from '@lemonade-hq/uniclient-chat';
import { useCallback } from 'react';

export interface UrlParams {
  readonly params: ClientUrlParams | null;
}

type GetUrlParamsFn = (url: URLProps) => ClientUrlParams | null;

export const useGetUrlParams = (): GetUrlParamsFn => {
  return useCallback((url: URLProps) => {
    try {
      const parsedParams = parseClientUrlParams(url);
      return parsedParams;
    } catch (e: unknown) {
      return null;
    }
  }, []);
};
